var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForklift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    enableBackground: "new 0 0 512.001 512.001",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m496.001,400h-112.001v-352c0-8.836-7.164-16-16-16s-16,7.164-16,16v256h-36.465l-45.769-137.305c-10.906-32.71-41.406-54.695-75.89-54.695h-81.875c-8.836,0-16.001,7.164-16.001,16v144h-79.999c-8.836,0-16.001,7.164-16.001,16v128c0,8.836 7.165,16 16.001,16h16c0,26.469 21.531,48 48,48 26.469,0 48-21.531 48-48h66.272c7.156,27.523 31.995,48 61.727,48 35.289,0 64-28.711 64-64v-16h32v16c0,8.836 7.165,16 16.001,16h128c8.836,0 16-7.164 16-16 0-8.836-7.164-16-16-16zm-256.594-223.179l42.394,127.179h-52.948l-37.781-25.184c-4.004-34.429-29.072-62.37-63.072-69.198v-65.618h65.876c20.687,0 38.992,13.188 45.531,32.821zm-111.407,66.129c14,4.832 24.219,15.496 29.052,29.051h-29.052v-29.051zm-47.999,205.05c-8.82,0-16-7.18-16-16 0-8.82 7.18-16 16-16s16,7.18 16,16c0,8.821-7.18,16-16,16zm35.515-48c-8.792-9.75-21.385-16-35.516-16-14.131,0-26.724,6.25-35.516,16h-12.484v-96h139.157l43.977,29.313c2.633,1.75 5.719,2.688 8.875,2.688h63.991v24.902c-9-5.512-20.292-8.902-32-8.902-29.732,0-54.571,20.477-61.727,48h-78.757zm140.485,47.999c-17.648,0-32-14.352-32-32 0-17.648 14.352-32 32-32 17.648,0 32,14.352 32,32 0,17.649-14.352,32-32,32zm63.999-80v-32h32v32h-32z",
    fill: "#006DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForklift);
export default __webpack_public_path__ + "static/media/forklift.a86d94b3d7307d9ef8f864d4c0052668.svg";
export { ForwardRef as ReactComponent };